import forge from "node-forge";
import BU from "@Common/util/buffer-util";
import { PrivateKey as PK } from "./interface";

export class PrivKey implements PK { 
    str:string;
    pk;
    constructor(str, pk?) {
        this.str = str;
        this.pk = pk || forge.pki.privateKeyFromPem(this.str);
    }
    sign(base64?:string, flags?:number) {
        return this.signRSA(base64, flags);

    }
    verify(msg?:string, b64sig?:string) {

    }
    getPublicKeyBlob() {
        //https://www.rfc-editor.org/rfc/rfc4253#section-6.6
        return this.getPublicKeyBlobRSA();
    }
    signRSA(base64:string, flags?) {
       
        let md;
        switch(flags) {
            case 1 << 1:
                md = forge.md.sha256.create();
                break; 
            case 2 << 2:
                md = forge.md.sha512.create();
                break; 
            default: 
                md = forge.md.sha1.create();
        }

        let str = atob(base64);
        md.update(str);
        let sig = this.pk.sign(md);
        return btoa(sig);
    }
    getPublicKeyBlobRSA() {
        
        let ba = this.pk.n.toByteArray();
       
        if(ba[0] === 0){
        //	ba.splice(0,1);
        }
        let str = 'ssh-rsa';
        let ab = new ArrayBuffer(
            4 //4 bytes - unsigned int: length X of string to come
            + str.length //X bytes - string: this will be 'ssh-rsa' (7 chars)
            + 4 //4 bytes - unsigned int: length Y of byte array
            + 4 //Y bytes - bigint of 'e'
            + 4 //4 bytes - unsigned int: length Z of byte array
            + ba.length  //Z bytes - bigint of 'n'
        );
        let dv = new DataView(ab);
        dv.setUint32(0,str.length);
        for(let i = 0; i< str.length; i++){
            dv.setUint8(4+i,str.charCodeAt(i));
        }
        dv.setUint32(4+str.length,4);
        dv.setUint32(8+str.length, this.pk.e);
        dv.setUint32(12+str.length,ba.length);
        let n = new Uint8Array(ab,16 +str.length);
        n.set(new Uint8Array(ba,0,ba.length -1));
        return BU.arrayBufferToBase64(ab);
    }
}
